<template>
    <div id="check-detail">
        <div class="drop-shadow-with-top">
            <table id="header">
                <tr>
                    <td><div id="corner-img" class="sprite folded-corner" /></td>
                    <td id="title" rowspan="2">
                        <a @click="setIsCheckDetailsShown(!isCheckDetailsShown)">
                            {{ detail.guestName }}
                            <img v-if="isCheckDetailsShown" src="~@/assets/images/caret-down.png" class="caret" />
                            <img v-else src="~@/assets/images/caret-right.png" class="caret" />
                        </a>
                    </td>
                </tr>
                <tr>
                    <td id="corner-img-spacer" />
                </tr>
            </table>
        </div>
        <transition name="fade-slide">
            <div id="orders" v-if="isCheckDetailsShown" class="drop-shadow-sides">
                <table v-for="order in detail.orderItems" :key="order.orderItemId">
                    <tr>
                        <td class="label-column">
                            <div>
                                {{ order.quantity + "\xa0\xa0\xa0" + order.menuItemName }}
                            </div>
                            <div v-if="order.components !== null && order.components.length > 0">
                                <ul>
                                    <li class="subitem-label" v-for="component in order.components" :key="component.orderItemId">
                                        {{ component.componentName }}
                                    </li>
                                </ul>
                            </div>
                            <div v-if="order.servingOptions !== null && order.servingOptions.length > 0">
                                <ul>
                                    <li class="subitem-label" v-for="servingOption in order.servingOptions" :key="servingOption.servingOptionId">
                                        {{ servingOption.servingOptionName }}
                                    </li>
                                </ul>
                            </div>
                        </td>
                        <td class="value-column">{{ (order.price * order.quantity) | toCurrency }}</td>
                    </tr>
                    <tr v-for="adjustment in filterAdjustments(order.adjustments)" :key="adjustment.adjustmentId">
                        <td class="label-column adjustment indented">{{ adjustment.adjustmentReasonName }}</td>
                        <td class="value-column adjustment">({{ adjustment.appliedAmount | toCurrency }})</td>
                    </tr>
                </table>
            </div>
        </transition>
        <TotalDetail :isTipVisible="false" />
    </div>
</template>

<script>
    import TotalDetail from "./TotalDetail";
    import { mapState, mapMutations } from "vuex";

    export default {
        name: "CheckDetail",
        components: {
            TotalDetail
        },
        props: {
            detail: Object
        },
        computed: {
            ...mapState({
                isCheckDetailsShown: state => state.session.isCheckDetailsShown
            })
        },
        methods: {            
            ...mapMutations([
                "setIsCheckDetailsShown"
            ]),
            filterAdjustments(adjustments) {
                return adjustments.filter(item =>
                    item.adjustmentReasonName.toLowerCase() !== "tax exempt");
            }
        }
    }
</script>

<style scoped>
    #header {
        width: 100%;
        text-align: left;
        border-collapse: collapse;
    }

    #header > tr:not(:first-child) {
        background: var(--white);
    }

    #header td:nth-child(2) {
        background: var(--white);
    }

    #header td:nth-child(1) {
        width: 30px;
    }

    #header > tr > td {
        padding: 0;
    }

    #corner-img {
        width: 30px;
        height: 30px;
        display: block;
        margin: 0;
    }

    #corner-img-spacer {
        height: 10px;
        border-bottom: var(--border-gray) solid 1px;
    }

    #title {
        font-size: 16px;
        font-weight: bold;
        border-bottom: var(--border-gray) solid 1px;
    }

    #orders {
        background: var(--white);
        padding: 10px;
        border-bottom: var(--border-gray) solid 1px;
    }

        #orders table, #total table {
            width: 100%;
        }

    .subitem-label {
        color: var(--text-gray);
        font-size: 14px;
    }

    .bold {
        font-weight: bold;
    }

    .caret {
        margin-left: 3px;
        width: 12px;
        cursor: pointer;
    }

    .indented {
        padding-left: 50px;
    }

    .adjustment {
        font-size: 13px;
        font-style: italic;
        color: var(--maroon-red);
    }

    ul {
        list-style-type: none;
        vertical-align: text-top;
        padding: 0;
        margin: 5px 0 0 30px;
    }
</style>